module.exports = __webpack_public_path__ + "img/256x256_hexagon_partial.cae03a30.svg";